import { IOS_COUNTRY_CODES } from '@/utils/country/country-codes'
import countriesData from '@/utils/country/countries.json'

export const TranslatableLanguageCodes = ['en', 'es', 'zh', 'de', 'fr', 'ru', 'pt', 'tr', 'sv', 'no', 'da', 'it', 'ja', 'fi', 'nl', 'ko', 'el', 'ms', 'vi', 'id', 'th', 'ar']
export const LocalizableLanguageCodes = ['en', 'zh', 'tr', 'es', 'de', 'it', 'ja', 'nl', 'ru', 'ko', 'ar', 'fr', 'bg', 'hr', 'is', 'id', 'pt', 'th', 'vi', 'zh', 'cs', 'da', 'fi', 'el', 'he', 'hu', 'ms', 'no', 'pl', 'ro', 'sk', 'sv']
export const AllLanguageCodes = ['aa', 'ab', 'af', 'ak', 'am', 'ar', 'an', 'as', 'av', 'ae', 'ay', 'az', 'ba', 'bm', 'be', 'bn', 'bh', 'bi', 'bo', 'bs', 'br', 'bg', 'ca', 'cs', 'ch', 'ce', 'cu', 'cv', 'kw', 'co', 'cr', 'cy', 'da', 'de', 'dv', 'dz', 'el', 'en', 'eo', 'et', 'eu', 'ee', 'fo', 'fa', 'fj', 'fi', 'fr', 'fy', 'ff', 'gd', 'ga', 'gl', 'gv', 'gn', 'gu', 'ht', 'ha', 'he', 'hz', 'hi', 'ho', 'hr', 'hu', 'hy', 'ig', 'io', 'ii', 'iu', 'ie', 'ia', 'id', 'ik', 'is', 'it', 'jv', 'ja', 'kl', 'kn', 'ks', 'ka', 'kr', 'kk', 'km', 'ki', 'rw', 'ky', 'kv', 'kg', 'ko', 'kj', 'ku', 'lo', 'la', 'lv', 'li', 'ln', 'lt', 'lb', 'lu', 'lg', 'mh', 'ml', 'mr', 'mk', 'mg', 'mt', 'mn', 'mi', 'ms', 'my', 'na', 'nv', 'nr', 'nd', 'ng', 'ne', 'nl', 'nn', 'nb', 'no', 'ny', 'oc', 'oj', 'or', 'om', 'os', 'pa', 'pi', 'pl', 'pt', 'ps', 'qu', 'rm', 'ro', 'rn', 'ru', 'sg', 'sa', 'si', 'sk', 'sl', 'se', 'sm', 'sn', 'sd', 'so', 'st', 'es', 'sq', 'sc', 'sr', 'ss', 'su', 'sw', 'sv', 'ty', 'ta', 'tt', 'te', 'tg', 'tl', 'th', 'ti', 'to', 'tn', 'ts', 'tk', 'tr', 'tw', 'ug', 'uk', 'ur', 'uz', 've', 'vi', 'vo', 'wa', 'wo', 'xh', 'yi', 'yo', 'za', 'zh', 'zu', 'fil']

const COUNTRY_LOOKUP = {}
countriesData.forEach((country) => {
  COUNTRY_LOOKUP[country.alpha2] = country
})

const iOSCountries = IOS_COUNTRY_CODES.map(code => COUNTRY_LOOKUP[code]).filter(Boolean)

function languageMap(code) {
  let language = null
  for (const cnt of iOSCountries) {
    const found = cnt.languages.find(lang => lang.code.toLowerCase() === code.toLowerCase())
    if (found) {
      language = found
      break
    }
  }
  if (!language) {
    language = { code, name: code.toUpperCase() }
  }
  const matchingCountries = iOSCountries.filter(cnt =>
    cnt.languages.some(lang => lang.code.toLowerCase() === code.toLowerCase()),
  )
  return {
    code,
    language,
    countries: matchingCountries,
  }
}

export const TranslatableLanguages = TranslatableLanguageCodes.map(languageMap)
export const LocalizableLanguages = LocalizableLanguageCodes.map(languageMap)
